import React from "react";
import { useState, useEffect, useMemo } from "react";
import {Container, Row, Col, Card} from "react-bootstrap";
import WelcomeHeader from "./Components/WelcomeHeader/WelcomeHeader";
import "./styles/Dashboard.css";
// import ChartCard from './Components/ChartCard/ChartCard';
import ChangePasswordModal from "../../components/ChangePasswordModal";
import DefaultPasswordReminderModal from "../../components/DefaultPasswordReminderModal";
import PlanSetChart from "./Components/Analytics/PlanSetChart";
import ClientsChart from "./Components/Analytics/ClientsChart";
import PlansetClientJobTypeChart from "./Components/Analytics/PlansetClientJobTypeChart";
// import StateWiseData from "./Components/Analytics/CityWiseData";
import LocationChart from "./Components/Analytics/LocationChart";
import UpcomingFeatures from "./Components/upcoming";

const Dashboard = () => {
  const userRole = Number(sessionStorage.getItem("userRole"));
  // for default password change
  const [showReminderModal, setShowReminderModal] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);

  useEffect ( () => {
     if (sessionStorage.getItem("usingDefaultPassword") === "true") {
        setShowReminderModal(true);
      }
  }, []);

  return (
    <Container fluid className="dashboard-content">
      <div className="container-fluid" style={{ padding: "10px 0" }}>
        <WelcomeHeader subtitle="Here's what's happening with your store today." />
        <Container fluid>
  {/* Admin */}
  {(userRole === 1 || userRole === 2) && (
            <>
              <Row className="g-3 mb-3">
                <Col lg={8}>
                  <div className="chart-inner-card">
                    <PlanSetChart />
                  </div>
                </Col>
                <Col lg={4}>
                  <div className="chart-inner-card">
                    <LocationChart />
                  </div>
                </Col>
              </Row>
              <Row className="mb-3">
                  <Col lg={12}>
                    <PlansetClientJobTypeChart />
                </Col>
              </Row>
              <Row className="mb-3">
                  <Col lg={12}>
                    <UpcomingFeatures />
                </Col>
              </Row>
            </>
          )}

          {/* Client */}
          {userRole === 3 && (
            <>
              <Row className="g-3 mb-3">
                <Col lg={8}>
                  <div className="chart-inner-card">
                    <PlanSetChart />
                  </div>
                </Col>
                <Col lg={4}>
                  <div className="chart-inner-card">
                    <LocationChart />
                  </div>
                </Col>
              </Row>
              <Row className="g-3 mb-3">
                <Col lg={12}>
                  <div className="chart-inner-card">
                    <UpcomingFeatures />
                  </div>
                </Col>
              </Row>
              </>
          )}          
</Container>
      </div>
      {/* chnage password modal */}
      <ChangePasswordModal
            show={showPasswordModal}
            handleClose={() => setShowPasswordModal(false)}
        />
        {/* for default password modal */}
        <DefaultPasswordReminderModal
              show={showReminderModal}
              handleClose={() => setShowReminderModal(false)}
              onChangePassword={() => setShowPasswordModal(true)}
          />
    </Container>
  );
};

export default Dashboard;